import React, { useState, useEffect } from 'react';
import { Modal } from './Modal';

interface DeptFormData {
  name: string;
  description: string;
}

interface Props {
  isOpen: boolean;
  mode: 'create' | 'edit';
  initialData: any;
  onClose: () => void;
  onSave: (data: DeptFormData) => Promise<void>;
}

const EMPTY: DeptFormData = { name: '', description: '' };

export const DeptFormModal: React.FC<Props> = ({
  isOpen, mode, initialData, onClose, onSave,
}) => {
  const [form, setForm] = useState<DeptFormData>(EMPTY);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    if (mode === 'edit' && initialData) {
      setForm({ name: initialData.name || '', description: initialData.description || '' });
    } else {
      setForm(EMPTY);
    }
  }, [isOpen, mode, initialData]);

  const set = (field: keyof DeptFormData) =>
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
      setForm(f => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async () => {
    setSaving(true);
    try {
      await onSave(form);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={mode === 'create' ? 'Create Department' : 'Edit Department'}>
      <div className="modal-body">
        <div className="form-field">
          <label>Name</label>
          <input value={form.name} onChange={set('name')} />
        </div>
        <div className="form-field">
          <label>Description</label>
          <textarea value={form.description} onChange={set('description')} />
        </div>
      </div>
      <div className="modal-footer">
        <button className="secondary-btn" onClick={onClose}>Cancel</button>
        <button className="primary-btn" onClick={handleSubmit} disabled={saving}>
          {saving ? 'Saving...' : 'Save'}
        </button>
      </div>
    </Modal>
  );
};
